<div class="container">
  <div class="label-container">
    <p
      class="label"
      [style]="{
        color: config().label.color,
        fontFamily: config().label.fontFamily,
      }"
    >
      {{ config().label.text }}
    </p>

    <p
      class="visits-reward"
      [style]="{
        color: config().visitsContainer.textColor,
        backgroundColor: config().visitsContainer.backgroundColor,
        fontFamily: config().visitsContainer.fontFamily,
      }"
    >
      <span
        class="reward-value"
        [innerHtml]="maxReward() | formatReward | safe"
      >
      </span>
      {{ config().visitsContainer.text }}
    </p>
  </div>
  <div class="button-container">
    <b2c-button
      [styles]="{
        fontSize: '12px',
        width: '250px',
        padding: '0.5rem 1rem',
        border: 'none',
        color: config().button.color,
        fontFamily: config().button.fontFamily,
        backgroundColor: config().button.backgroundColor,
        textTransform: config().button.textTransform,
      }"
      data-cy="select_btn"
      [title]="config().button.title"
      [loading]="selectionInProgress()"
      [attr.aria-label]="config().button.title"
      (click)="
        selectChallenge(
          challenge(),
          phase(),
          isBisCampaign(),
          isEventChallenge()
        )
      "
      [disabled]="
        challenge().isOutOfStock() ||
        selectionInProgress() ||
        blockSelectionButton()
      "
    >
      {{ config().button.label }}
    </b2c-button>
  </div>
</div>
